import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import { recommendStoreActions } from '../../../store/modules/recommend/store';
import RecommendStoreDetailWrap from '../../../views/recommend/store/detail/RecommendStoreDetailWrap';

class RecommendStoreDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (recommendStoreId) => {
    const { getRecommendStoreDetail } = this.props;

    getRecommendStoreDetail({
      recommendStoreId,
    });
  };

  render() {
    const { recommendStoreDetail } = this.props;

    return <RecommendStoreDetailWrap recommendStoreDetail={recommendStoreDetail} />;
  }
}

const mapStateToProps = (state) => {
  return {
    recommendStoreDetail: state.recommendStore.recommendStoreDetail,
  };
};

const mapDispatchToProps = {
  getRecommendStoreDetail: recommendStoreActions.getRecommendStoreDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RecommendStoreDetailContainer));
